import { GroupBase, StylesConfig } from "react-select";

/**
 * react-select styles that match the admin input (`.inp`) from
 * `stories/Admin`, so searchable selects look like the other fields.
 */
export function adminSelectStyles<
  Option,
  IsMulti extends boolean = false,
>(): StylesConfig<Option, IsMulti, GroupBase<Option>> {
  return {
    control: (base, state) => ({
      ...base,
      minHeight: 42,
      borderRadius: 12,
      background: state.isDisabled ? "#F4F7F5" : "#FFFFFF",
      borderColor: state.isFocused ? "#1D7A52" : "#D5DED9",
      boxShadow: state.isFocused ? "0 0 0 3px rgba(29,122,82,0.15)" : "none",
      fontSize: 14,
      "&:hover": { borderColor: state.isFocused ? "#1D7A52" : "#C3CFC9" },
    }),
    valueContainer: (base) => ({ ...base, padding: "0 12px" }),
    input: (base) => ({ ...base, color: "#0D2A33" }),
    singleValue: (base) => ({ ...base, color: "#0D2A33" }),
    placeholder: (base) => ({ ...base, color: "#8A9C96" }),
    indicatorSeparator: () => ({ display: "none" }),
    dropdownIndicator: (base) => ({
      ...base,
      color: "#546A71",
      paddingRight: 12,
    }),
    clearIndicator: (base) => ({ ...base, color: "#8A9C96" }),
    menuPortal: (base) => ({ ...base, zIndex: 1200 }),
    menu: (base) => ({
      ...base,
      borderRadius: 12,
      overflow: "hidden",
      fontSize: 14,
      color: "#0D2A33",
      boxShadow: "0 12px 32px rgba(6,37,47,0.16)",
      border: "1px solid #E2E9E5",
    }),
    option: (base, state) => ({
      ...base,
      background: state.isSelected
        ? "#0B3B4C"
        : state.isFocused
          ? "#F1FAF5"
          : "#FFFFFF",
      color: state.isSelected ? "#FFFFFF" : "#0D2A33",
      cursor: "pointer",
    }),
    noOptionsMessage: (base) => ({ ...base, color: "#546A71" }),
  };
}
